/**
 * Custom event name dispatched when the org list should refresh (e.g. after
 * a passwordless orgfarm org is connected in SpecialtyOrgManager).
 * OrgPickerContainer listens for this and calls th-org-picker's refresh().
 */
export const TH_ORG_PICKER_REFRESH_EVENT = 'th-org-picker-refresh';
